import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { REG_HUB_COMMON_CONFIG, RegHubCommonConfig } from '../../reg-hub-common-config';
import { UltimateBeneficialOwnershipRequestDocument } from '../../interfaces/ultimate-beneficial-ownership-request-documents/ultimate-beneficial-ownership-request-document';
import { UltimateBeneficialOwnershipRequestDocumentForUpdate } from '../../interfaces/ultimate-beneficial-ownership-request-documents/ultimate-beneficial-ownership-request-document-for-update';


@Injectable({
  providedIn: 'root'
})
export class UltimateBeneficialOwnershipRequestDocumentsService {
  protected _baseLink: string;

  constructor(
    @Inject(REG_HUB_COMMON_CONFIG) private config: RegHubCommonConfig,
    private http: HttpClient,
  ) {
    this._baseLink = `${this.config.rootUrl}/UltimateBeneficialOwnership`;
  }

  public updateUltimateBeneficialOwnershipRequestDocument(ultimateBeneficialOwnershipRequestID: string, ultimateBeneficialOwnershipRequestDocumentID: string, ultimateBeneficialOwnershipRequestDocument: UltimateBeneficialOwnershipRequestDocumentForUpdate): Observable<UltimateBeneficialOwnershipRequestDocument> {
    return this.http.put<UltimateBeneficialOwnershipRequestDocument>(`${this._baseLink}/${ultimateBeneficialOwnershipRequestID}/Documents/${ultimateBeneficialOwnershipRequestDocumentID}`, ultimateBeneficialOwnershipRequestDocument);
  }
}
